/**
 * .select2 through Conferences
 * Remote search Conferences
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

;$(function(){

    "use strict";

    /**
     * Format output
     *
     * @param  conference
     * @return string
     */
    function formatConference (conference) {
        if (conference.loading) return conference.text;
        // Initialize
        var markup = "<div class='select2-result-conference clearfix'>" +
            "<div class='select2-result-conference__meta'>" +
                "<div class='select2-result-conference__label'>" +
                conference.dropdown_label + ' on ' +
                moment(conference.exibitor_start_date).format('LL') + "</div>"
        // If we have the address
        if (conference.conference_address) {
            markup += "<div class='select2-result-conference__address'><small>" +
                conference.conference_address.address_line + "," + conference.conference_address.city_state_zip +
            "</small></div>";
        }
        // Return
        return markup;
    }



    /**
     * Format the selection
     *
     * @param  conference
     * @return string
     */
    function formatConferenceSelection (conference) {
        return conference.dropdown_label || conference.text
    }

    /**
     * Register the Selector
     *
     * @return void
     */
    var select2Conferences = function(){
        $(".search-conference.select2").select2({
            ajax: {
                url: "/api/v3/conferences",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        query: params.term,
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;

                    return {
                        results: data.data,
                        pagination: {
                            more: (params.page * 30) < data.total
                        }
                    };
                },
                cache: true
            },
            placeholder: "Search for a Conference...",
            theme: "bootstrap",
            escapeMarkup: function (markup) { return markup; },
            minimumInputLength: 1,
            templateResult: formatConference,
            templateSelection: formatConferenceSelection
        });
    }
    // Attach the function to load event
    $(document).ready(select2Conferences);
});
